import { type UseQueryResult, useQuery } from 'react-query';
import { WarrantParticipantService } from '../../services/wealthlane-captable-services';

const useGetParticipantWarrantList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  isEsppOnly?: boolean
): UseQueryResult<any | undefined, unknown> => {
  return useQuery(
    ['getParticipantWarrantList'],
    async () => {
      return await handleRequest(
        WarrantParticipantService.getApiCapTableApiAppWarrantParticipantParticipantWarrantList()
      );
    },
    {
      enabled: !isEsppOnly,
    }
  );
};

export default useGetParticipantWarrantList;
